module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/banner_img-e1e12c3e1b0b75f47c75f71cef8b0017.png";